import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const PublicRoute = () => {
  const tokenAuth = localStorage.getItem("1dTkApp");

  if (tokenAuth) {
    return <Navigate to={"/home"} replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
